function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "contacts-import",
  transform: "translate(-871.000000, -273.000000)",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "import",
  transform: "translate(803.000000, 184.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "platform-buttons",
  transform: "translate(50.000000, 82.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "button-importfile"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-importfile",
  transform: "translate(18.000000, 7.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.7142857,15 L24.8571429,15 C24.3857143,15 24,15.3970588 24,15.8823529 C24,16.3676471 24.3857143,16.7647059 24.8571429,16.7647059 L31.7142857,16.7647059 C33.1285714,16.7647059 34.2857143,17.9558824 34.2857143,19.4117647 L34.2857143,40.5882353 C34.2857143,42.0441176 33.1285714,43.2352941 31.7142857,43.2352941 L4.28571429,43.2352941 C2.87142857,43.2352941 1.71428571,42.0441176 1.71428571,40.5882353 L1.71428571,19.4117647 C1.71428571,17.9558824 2.87142857,16.7647059 4.28571429,16.7647059 L12,16.7647059 C12.4714286,16.7647059 12.8571429,16.3676471 12.8571429,15.8823529 C12.8571429,15.3970588 12.4714286,15 12,15 L4.28571429,15 C1.92857143,15 0,16.9852941 0,19.4117647 L0,40.5882353 C0,43.0147059 1.92857143,45 4.28571429,45 L31.7142857,45 C34.0714286,45 36,43.0147059 36,40.5882353 L36,19.4117647 C36,16.9852941 34.0714286,15 31.7142857,15 Z",
  id: "Path",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4390244,2.64705882 C18.9219512,2.64705882 19.3170732,2.30672269 19.3170732,1.8907563 L19.3170732,0.756302521 C19.3170732,0.340336134 18.9219512,0 18.4390244,0 C17.9560976,0 17.5609756,0.340336134 17.5609756,0.756302521 L17.5609756,1.8907563 C17.5609756,2.30672269 17.9560976,2.64705882 18.4390244,2.64705882 Z",
  id: "Path",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.92596261,23.3382353 C9.56939458,23.6911765 9.56939458,24.2205882 9.92596261,24.5735294 L17.8150303,32.3823529 C17.9933143,32.5588235 18.2161694,32.6470588 18.4390244,32.6470588 C18.6618794,32.6470588 18.8847344,32.5588235 19.0630184,32.3823529 L26.9520862,24.5735294 C27.3086542,24.2205882 27.3086542,23.6911765 26.9520862,23.3382353 C26.5955181,22.9852941 26.0606661,22.9852941 25.7040981,23.3382353 L19.3304445,29.6470588 L19.3304445,6.17647059 C19.3304445,5.69117647 18.9293054,5.29411765 18.4390244,5.29411765 C17.9487433,5.29411765 17.5476043,5.69117647 17.5476043,6.17647059 L17.5476043,29.6470588 L11.1739507,23.3382353 C10.8173827,22.9852941 10.2825306,22.9852941 9.92596261,23.3382353 Z",
  id: "Path",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("text", {
  id: ".CSV",
  fontFamily: "Lato-Bold, Lato",
  fontSize: 12,
  fontWeight: "bold"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 5,
  y: 57
}, ".CSV"))))))));

function SvgIconImportfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "58px",
    viewBox: "0 0 36 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-importfile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportfile);
export default __webpack_public_path__ + "static/media/icon-importfile.bcb8451f.svg";
export { ForwardRef as ReactComponent };